import { lazy, Suspense } from "react";
import { SALES_ROUTES, USER_ROUTES } from "../constants/appRoutes";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../components/Loader";
const EditLeadPage = lazy(() => import("../pages/admin/Leads/EditLead"));

const SalesDashboard = lazy(() => import("../pages/sales/Dashboard"));
const DroneView = lazy(() => import("../pages/sales/DroneView"));
const Profile = lazy(() => import("../pages/admin/Profile/Profile"));

const Leads = lazy(() => import("../pages/admin/Leads/Leads"));
// const NewLead = lazy(() => import("../pages/admin/Leads/NewLead"));

const SalesRoutes = () => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-[100vh]">
          <Loader />
        </div>
      }
    >
      <Routes>
        <Route path={USER_ROUTES.ROOT} element={<SalesDashboard />}></Route>
        <Route path={SALES_ROUTES.PROFILE} element={<Profile />} />

        <Route path={SALES_ROUTES.ENQUIRY} element={<Leads />}></Route>
        <Route
          path={SALES_ROUTES.ENQUIRY_EDIT_LEAD_ID}
          element={<EditLeadPage isEdit={true} />}
        />
        <Route
          path={SALES_ROUTES.ENQUIRY_VIEW_LEAD_ID}
          element={<EditLeadPage isEdit={false} />}
        />
        <Route path={SALES_ROUTES.DRONE_VIEW} element={<DroneView />}></Route>
        {/* <Route path={SALES_ROUTES.NEW_ENQUIRY} element={<NewLead />}></Route> */}

        <Route
          path={USER_ROUTES.NOT_FOUND}
          element={<Navigate to={SALES_ROUTES.ROOT} />}
        />
      </Routes>
    </Suspense>
  );
};

export default SalesRoutes;
